import { render, staticRenderFns } from "./BotaoExcluir.vue?vue&type=template&id=47c936ea&scoped=true"
import script from "./BotaoExcluir.vue?vue&type=script&lang=js"
export * from "./BotaoExcluir.vue?vue&type=script&lang=js"
import style0 from "./BotaoExcluir.vue?vue&type=style&index=0&id=47c936ea&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47c936ea",
  null
  
)

export default component.exports